import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const AccountDetails = ({
  color = colors.primary,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill={color}
          style={style as React.CSSProperties}
        >
          <path
            d="M16.5996 21.0996C19.0849 21.0996 21.0996 19.0849 21.0996 16.5996C21.0996 14.1143 19.0849 12.0996 16.5996 12.0996C14.1143 12.0996 12.0996 14.1143 12.0996 16.5996C12.0996 19.0849 14.1143 21.0996 16.5996 21.0996Z"
            fill={fillColor}
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M24.7 17.5H35.5M24.7 22.9H35.5M28.3 28.3H35.5M24.7 31.9C24.34 27.76 20.74 24.7 16.6 24.7C12.46 24.7 8.86 27.94 8.5 31.9"
            fill={fillColor}
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill={color}
      style={style}
      {...props}
    >
      <Path
        d="M16.5996 21.0996C19.0849 21.0996 21.0996 19.0849 21.0996 16.5996C21.0996 14.1143 19.0849 12.0996 16.5996 12.0996C14.1143 12.0996 12.0996 14.1143 12.0996 16.5996C12.0996 19.0849 14.1143 21.0996 16.5996 21.0996Z"
        fill={fillColor}
        stroke={color}
        strokeWidth="2"
      />
      <Path
        d="M24.7 17.5H35.5M24.7 22.9H35.5M28.3 28.3H35.5M24.7 31.9C24.34 27.76 20.74 24.7 16.6 24.7C12.46 24.7 8.86 27.94 8.5 31.9"
        fill={fillColor}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
};
